import { AutoMap } from "@automapper/classes";
import { ELIMSProduct } from "./ELIMS/ELIMS-Product";
import { TestGroup } from "./test-group"

export class ProductGroup {
    public constructor(init?: Partial<ProductGroup>) {
        Object.assign(this, init);
    }
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Name: string = ''
    @AutoMap(() => [TestGroup])
    TestGroupList: TestGroup[] = [];
    @AutoMap(() => [ELIMSProduct])
    ElimsProductList: ELIMSProduct[] = [];

}